// src/MapLibreMap.js
import React from 'react';
import { Map, Marker } from '@vis.gl/react-maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';

/**
 * Renders a map using @vis.gl/react-maplibre, plus a marker at given lat/lng.
 *
 * The basemap defaults to `/settings/positron.json`, served from public/. Override it
 * with `mapStyle` -- note the name, since a prop React does not recognise is simply
 * ignored, which is how a call site once passed `styleUrl` and silently got the default.
 * Do not point it at demotiles.maplibre.org: that is MapLibre's public demo server, not
 * something to depend on in production.
 *
 * Usage example:
 *   <MapLibreMap
 *     lat={25.24547}
 *     lng={51.454009}
 *     zoom={12}
 *     markerImage="/pin.png"
 *   />
 */
function MapLibreMap({
  lat = 0,
  lng = 0,
  zoom = 8,
  mapStyle = '/settings/positron.json',
  width = '100%',
  height = 400,
  markerImage = null
}) {
  if (lat == null || lng == null) {
    return <div>Coordinates not available</div>;
  }

  return (
    <div style={{ width, height }}>
      <Map
        initialViewState={{
          longitude: lng,
          latitude: lat,
          zoom
        }}
        style={{ width: '100%', height: '100%' }}
        mapStyle={mapStyle}
      >
        <Marker
          longitude={lng}
          latitude={lat}
          anchor="bottom"
        >
          {markerImage ? (
            <img src={markerImage} alt="marker" />
          ) : (
            // If no child is provided, the library uses a default marker
            null
          )}
        </Marker>
      </Map>
    </div>
  );
}

export default MapLibreMap;
